import React from "react";

const Body = ({ renderField, renderSelect, ...props }) => {
    const { name, regionIds } = props;

    return (
        <>
            {renderField(name)}
            {renderSelect(regionIds)}
        </>
    );
};

export default Body;
